import { make } from 'vuex-pathify';
import initialState from './state';

export default {
    ...make.getters(initialState),

    fieldById: state => (id) => {
        const sectionIndex = state.document.sections.findIndex(s => s.fields.find(f => f.id === id));

        const fieldIndex = state.document.sections[sectionIndex].fields.findIndex(f => f.id === id);

        return state.document.sections[sectionIndex].fields[fieldIndex];
    },
};
